import { render } from "./clinic-show.vue?vue&type=template&id=afb7727e&scoped=true"
import script from "./clinic-show.vue?vue&type=script&lang=js"
export * from "./clinic-show.vue?vue&type=script&lang=js"

import "./clinic-show.vue?vue&type=style&index=0&id=afb7727e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb7727e"]])

export default __exports__